import { Col, Row, Modal, Form, Select, Button, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import Title from "../../UI/Title/Title";
import { createItemComponent } from "../../../api/itemComponent";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import { ItemComponentType } from "./componentType";
import { useParams } from "react-router";
import { getItemUnitDropdown } from "../../../api/itemUnit";
import { Dispatch, useState } from "react";
import { getComponentsDropdown } from "../../../api/refcomponents";
import { getItemsBy } from "../../../api/itemapi";
import { AxiosResponse } from "axios";
import { InputNumber } from "../../UI/InputNumberComponent/inputnumber";

type propsType = {
  openComponent: boolean;
  setOpenComponent: React.Dispatch<React.SetStateAction<boolean>>;
  ItemComponentMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      itemid: string | number | undefined;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  filter: any;
  itemId: string | undefined;
  search: any;
  setPaginatedItemComponent: Dispatch<any>;
};
interface selectOption {
  id: number;
  value: string;
}

export const AddComponent = ({
  openComponent,
  setOpenComponent,
  ItemComponentMutation,
  filter,
  itemId,
  search,
  setPaginatedItemComponent,
}: propsType) => {
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const [, setError] = useState("");
  const { id } = useParams();
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState<any>(null);
  const [selectedUnit, setSelectedUnit] = useState<any>(null);
  const [, setInitialValues] = useState({ isActive: undefined });
  const handleNameChange = (value: any) => {
    setQuantity(value);
  };

  useQuery("item", () => getItemsBy(id), {
    onSuccess: (itemName) => {
      setItemName(itemName);
    },
  });

  const [formatedItemUnit, setFormatedItemUnit] = useState<selectOption[]>();
  const { isLoading: loadingItemUnit } = useQuery(
    "ItemUnit",
    getItemUnitDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedItemUnit(
          res.data
            .map((unit: any) => {
              if (unit.isActive) {
                return { value: unit.id, label: unit.name };
              } else {
                return null;
              }
            })
            .filter((unit: any) => unit !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  const [formatedComponents, setFormatedComponents] =
    useState<selectOption[]>();
  const { isLoading: loadingComponents } = useQuery(
    "component",
    getComponentsDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedComponents(
          res.data
            .map((component: any) => {
              if (component.isActive) {
                return { value: component.id, label: component.name };
              } else {
                return null;
              }
            })
            .filter((component: any) => component !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  const onError = (
    error: any,
    variables: ItemComponentType,
    context: unknown
  ) => {
    let errorMessage = "An error occurred";
    if (error.response && error.response.data && error.response.data.errors) {
      const errorData = error.response.data.errors[0];
      if (errorData && errorData.msg) {
        errorMessage = `${errorData.param} ${errorData.msg}`;
      }
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      errorMessage = error.response.data.message;
    } else {
      errorMessage = error.message;
    }
    if (setError) {
      setError(errorMessage);
    }
    message.error({
      content: errorMessage,
      duration: 10,
      onClick: () => {
        message.destroy();
      },
    });
    // if (!setError) {
    //   message.success("Saved successfully!");
    // }
  };

  const { mutateAsync: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    "createItemComponent",
    (item: ItemComponentType) => createItemComponent(item),
    {
      onSuccess: (res) => {
        message.success("Complete successfully");
        ItemComponentMutation({
          itemid: itemId,
          q: search,
          isActive: filter,
        }).then((res: any) => {
          setPaginatedItemComponent(res.data);
        });
      },
      onError,
    }
  );

  const handleFinish = async (Close: boolean) => {
    const newItemComponent = form.getFieldsValue();
    for (const key in newItemComponent) {
      if (newItemComponent[key] === undefined) {
        if (key === "isActive") {
          newItemComponent[key] = true;
        } else {
          newItemComponent[key] = null;
        }
      } else if (
        typeof newItemComponent[key] === "string" &&
        newItemComponent[key].trim() === ""
      ) {
        newItemComponent[key] = null;
      }
    }
    newItemComponent["itemId"] = id;
    mutateCreateUpdate(newItemComponent).then(() => {
      Close && setOpenComponent(false);
      form.resetFields();
    });
  };

  const handleCancel = () => {
    form.resetFields();
    setSelectedComponent(null);
    setSelectedUnit(null);
    setQuantity(false);
    setOpenComponent(false);
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      centered
      width={450}
      onCancel={() => setOpenComponent(false)}
      open={openComponent}
      cancelText="Cancel"
      cancelButtonProps={{
        style: { color: "#1677FF", border: "1px solid #1677FF" },
      }}
      footer={null}
    >
      <Form
        className="no-hover-label"
        data-testid="form"
        layout="vertical"
        form={form}
        onFinish={() => handleFinish(false)}
        id="Componentform"
      >
        <Col offset={1}>
          <Title title={`${t("add-component")}`} />
        </Col>

        <Row style={{ marginTop: "15px" }}>
          <Col span={19} offset={1}>
            <Col className="modaltitleEdit">
              {t("add-components-to")} {""} {itemName}
            </Col>
            <Form.Item
              name="componentId"
              label={t("component")}
              rules={[
                {
                  required: true,
                  message: "component is required",
                },
              ]}
            >
              <Select
                data-testid="component"
                placeholder={t("select-component")}
                showSearch={true}
                loading={loadingComponents}
                options={formatedComponents}
                optionFilterProp="label"
                onChange={(value: any) => setSelectedComponent(value)}
              />
            </Form.Item>

            <Form.Item
              name="quantity"
              label={t("amount")}
              rules={[
                {
                  required: true,
                  message: "amount is required",
                },
              ]}
            >
              <InputNumber maxLength={11} onChange={handleNameChange} />
            </Form.Item>

            <Form.Item
              name="unitId"
              label={t("unit")}
              rules={[
                {
                  required: true,
                  message: "unit is required",
                },
              ]}
            >
              <Select
                data-testid="unit"
                placeholder={t("select-unit")}
                loading={loadingItemUnit}
                options={formatedItemUnit}
                showSearch={true}
                optionFilterProp="label"
                onChange={(value: any) => setSelectedUnit(value)}
              />
            </Form.Item>
            <Form.Item
              label={`${t("status")}`}
              name="isActive"
              valuePropName="checked"
            >
              <Switch
                checkedChildren={`${t("active")}`}
                unCheckedChildren={`${t("inactive")}`}
                defaultChecked
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Col offset={1}>
            <Button
              data-testid="cancel"
              size="large"
              style={{
                color: "#1677FF",
                border: "1px solid #1677FF",
                width: "100px",
              }}
              onClick={() => {
                handleCancel();
                setOpenComponent(false);
              }}
            >
              {t("cancel")}
            </Button>
          </Col>
          <Col offset={4}>
            <Button
              style={{
                width: "100px",
                background: "#1677FF",
                color: "#fff",
                height: "40px",
                border: "none",
              }}
              onClick={() => {
                handleFinish(true);
              }}
              disabled={
                !quantity || !selectedComponent || !selectedUnit || isSaving
              }
            >
              {isSaving ? `${t("loading")}` : `${t("Save & Close")}`}
            </Button>
          </Col>
          <Col offset={1}>
            <Button
              data-testid="save"
              htmlType="submit"
              form="Componentform"
              style={{
                width: "100px",
                background: "#1677FF",
                color: "#fff",
                height: "40px",
                border: "none",
              }}
              disabled={
                !quantity || !selectedComponent || !selectedUnit || isSaving
              }
            >
              {isSaving ? `${t("loading")}` : `${t("save-&-add")}`}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
